import { picoapp } from "picoapp";
import accountLogin from "@/components/accountLogin.js";

const components = {
  accountLogin,
};

export default picoapp(components);
